import React from 'react';
import { motion } from 'framer-motion';
import { HashIcon, SunIcon, StarIcon } from 'lucide-react';
const pillars = [{
  title: 'La Estructura',
  subtitle: '(Numerología)',
  description: 'Tu plan de encarnación y tus lecciones vitales.',
  icon: HashIcon,
  color: 'from-trino-burgundy to-trino-rose'
}, {
  title: 'La Frecuencia',
  subtitle: '(Tzolkin Maya)',
  description: 'Tu firma galáctica y tu esencia de servicio al mundo.',
  icon: SunIcon,
  color: 'from-trino-gold to-trino-gold-dark'
}, {
  title: 'El Ritmo',
  subtitle: '(Astrología)',
  description: 'Los ciclos planetarios que activan tu mapa emocional y de acción.',
  icon: StarIcon,
  color: 'from-trino-coral to-trino-rose'
}];
export function TripleHelixMechanism() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-136">
      {/* Background SVG */}
      <div className="absolute inset-0 pointer-events-none opacity-5 flex items-center justify-center" data-id="element-137">
        <svg width="600" height="600" viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-138">
          <path d="M300 50 L550 483 L50 483 Z" stroke="#ff0048" strokeWidth="2" data-id="element-139" />
          <path d="M300 550 L50 117 L550 117 Z" stroke="#ff0048" strokeWidth="2" data-id="element-140" />
          <circle cx="300" cy="300" r="200" stroke="#ff0048" strokeWidth="2" data-id="element-141" />
        </svg>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-143">
          <span className="text-trino-gold-dark font-semibold tracking-widest uppercase text-sm mb-2 block" data-id="element-144">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold font-serif text-trino-burgundy mb-6" data-id="element-145">
            La Trinidad
          </h2>
          <p className="text-xl text-trino-dark/70 max-w-3xl mx-auto" data-id="element-146">
            Presentamos la tecnología de reconocimiento que une tres dimensiones
            en una sola hoja de ruta:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-147">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: index * 0.2
        }} className="relative group" data-id="element-148">
              <div className="absolute inset-0 bg-gradient-to-b from-trino-cream to-white rounded-2xl transform transition-transform group-hover:-translate-y-2 group-hover:shadow-xl duration-300 border border-trino-peach/50" data-id="element-149"></div>
              <div className="relative p-8 text-center h-full flex flex-col items-center" data-id="element-150">
                <div className={`w-20 h-20 rounded-full bg-gradient-to-br ${pillar.color} flex items-center justify-center text-white mb-6 shadow-lg transform group-hover:scale-110 transition-transform duration-300`} data-id="element-151">
                  <pillar.icon className="w-10 h-10" data-id="element-152" />
                </div>
                <h3 className="text-2xl font-serif font-bold text-trino-burgundy mb-1" data-id="element-153">
                  {pillar.title}
                </h3>
                <h4 className="text-trino-gold-dark font-medium mb-4" data-id="element-154">
                  {pillar.subtitle}
                </h4>
                <p className="text-trino-dark/70 leading-relaxed" data-id="element-155">
                  {pillar.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}